import { UserSettings } from 'src/types/UserSettings.ts';
import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { sortAccessories } from 'src/modules/common/utils/sortAccessories.ts';
import { ActuatorAccessoriesPageData } from 'src/actuators/accessories/ActuatorAccessoriesPageMapping.ts';
import { LocationState } from 'src/actuators/LocationState.ts';

export const calculateTotals = (
    {
        actuator,
        accessories: actuatorAccessories,
    }: ActuatorAccessoriesPageData['accessories'],
    userSettings: UserSettings,
    checkoutState: LocationState,
    currency: string | null,
): {
    subtotal: number;
    accessoriesSubtotal: number;
    total: number;
    currentCurrency: string;
    accessories: ActuatorAccessoriesPageData['accessories']['accessories'];
    pricePerUnit: number;
} => {
    const actuatorPrice = getPriceValue(actuator, userSettings.shoppingCenter as keyof typeof actuator, currency);
    const currentCurrency = actuatorPrice?.currency || currency || 'USD';
    const pricePerUnit = actuatorPrice ? actuatorPrice.value : 0;
    const subtotal = (actuatorPrice ? actuatorPrice.value : 0) * checkoutState.qty;

    const accessories = [
        ...actuatorAccessories,
    ].reduce((acc, curr) => {
        const exist = acc.find((item) => item.item.Label === curr.item.Label);
        if (!exist && checkoutState.selectedAccessories.find(({ label }) => label === curr.item.Label) !== undefined) {
            acc.push(curr);
        }
        return acc;
    }, [] as ActuatorAccessoriesPageData['accessories']['accessories'])
        .sort(sortAccessories);

    const accessoriesSubtotal = accessories
        .reduce((acc, { item }) => {
            const price = getPriceValue(item, userSettings.shoppingCenter as keyof typeof item, currency);
            if (!price) {
                return acc;
            }
            const accessoryItem = checkoutState.selectedAccessories.find(({ label }) => label === item.Label);
            const qty = accessoryItem ? accessoryItem.qty : 1;
            return acc + (price.value * qty);
        }, 0);

    const total = subtotal + accessoriesSubtotal;

    return {
        subtotal,
        accessoriesSubtotal,
        total,
        currentCurrency,
        accessories,
        pricePerUnit,
    };
};
